import axios from 'axios';

const DEBUG_PREFIX = '[SselTrackingService]';

const CHECKOUT_PAGE_TYPES = Object.freeze({
  PAYMENT: 'checkout2',
  CONFIRMATION: 'checkout3',
});
// For consistency with other tracking events
const DESTINATION_URL_BY_PAGE_TYPE = {
  [CHECKOUT_PAGE_TYPES.PAYMENT]: '/shop/checkout/details/payment',
  [CHECKOUT_PAGE_TYPES.CONFIRMATION]: '/shop/checkout/details/confirmation',
};

const resolveDestinationUrl = (pageType) => {
  if (typeof window === 'undefined' || !pageType) return null;

  const destinationPath = DESTINATION_URL_BY_PAGE_TYPE[pageType];
  if (!destinationPath) return null;

  return `${window.location.origin}${destinationPath}`;
};

export const trackPageType = (pageType) => {
  const url = resolveDestinationUrl(pageType);

  const payload = {
    page_type: pageType,
    url,
  };

  if (!pageType || !url) {
    // eslint-disable-next-line no-console
    console.log(`${DEBUG_PREFIX} skipped (invalid params) ‼️ ❌`, payload);
    return;
  }

  axios
    .post('/ssel/t', payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .catch((error) => {
      // swallow errors: tracking must not break checkout flow
      // TBD: collect errors in newrelic
      // eslint-disable-next-line no-console
      console.error(`${DEBUG_PREFIX} request failed ❌`, { payload, error });
    });
};

export const trackCheckoutStep = (step) => {
  trackPageType(step);
};

export const trackCheckoutPayment = () => {
  trackCheckoutStep(CHECKOUT_PAGE_TYPES.PAYMENT);
};

export const trackCheckoutConfirmation = () => {
  trackCheckoutStep(CHECKOUT_PAGE_TYPES.CONFIRMATION);
};
